'use client'

import { HttpAction, handleHttpError, performHttpRequest } from '@/clients/http'
import { AppState } from '@/clients/redux/store'
import { PayloadAction, Slice, createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { HttpState, createStateObject, httpInitialState } from './httpInitialState'

export const performHttpCall = createAsyncThunk(
  'http/sendRequest',
  async (payload: HttpAction, thunkAPI) => {
    const { payload: httpPayload } = payload

    try {
      return await performHttpRequest(httpPayload)
    } catch (e: any) {
      handleHttpError(e)
      throw thunkAPI.rejectWithValue(e)
    }
  }
)

export const httpSlice: Slice<Partial<HttpState>> = createSlice({
  name: 'http',
  initialState: httpInitialState,
  reducers: {
    resetHttpStates() {
      return {
        ...httpInitialState,
      }
    },
    resetHttpState(
      state,
      action: PayloadAction<{
        coreRelationKey: keyof HttpState
        data: any
      }>
    ) {
      return {
        ...state,
        [action?.payload?.coreRelationKey]: {
          ...(createStateObject(action?.payload?.data) as any),
        },
      }
    },
  },
  extraReducers(builder) {
    builder.addCase(performHttpCall.pending, (state, { meta }) => {
      state[meta.arg.correlationKey] = {
        // ...(state as any)[meta.arg.correlationKey],
        correlationKey: meta.arg.correlationKey?.toString(),
        loading: true,
        success: false,
        error: null,
        data: null,
        payload: meta?.arg?.payload?.body,
      }
    })
    builder.addCase(performHttpCall.rejected, (state, { meta, payload }) => {
      const actionPayload: any = payload

      state[meta.arg.correlationKey] = {
        ...state[meta.arg.correlationKey],
        correlationKey: meta.arg.correlationKey?.toString(),
        loading: false,
        success: false,
        data: null,
        error: actionPayload?.response ?? actionPayload,
        payload: meta?.arg?.payload?.body,
      }
    })
    builder.addCase(performHttpCall.fulfilled, (state, { meta, payload }) => {
      state[meta.arg.correlationKey] = {
        ...state[meta.arg.correlationKey],
        correlationKey: meta.arg.correlationKey?.toString(),
        loading: false,
        success: true,
        error: null,
        data: payload?.data,
        payload: meta?.arg?.payload?.body,
      }
    })
  },
})

export const selectHttpState = (state: AppState) => state.http
export const { resetHttpStates, resetHttpState } = httpSlice.actions
export default httpSlice.reducer
